// Import Tailwind (incl. Reset)
import 'tailwindcss/tailwind.css';

// Import Styles
import './styles/index.scss';

    //variables
    import './styles/variables/_grid.scss';
    import './styles/variables/_colors.scss';
    import './styles/variables/_font.scss';
    import './styles/variables/_spacing.scss';

    //base
    import './styles/base/_base.scss';
    import './styles/base/_header.scss';
    import './styles/base/_burger.scss';
    import './styles/base/_gform.scss';
    import './styles/base/_typographie.scss';
    import './styles/base/_spacing.scss';
    import './styles/base/_footer.scss';
    import './styles/base/_sirv.scss';

    //components¨
    import './styles/components/_cover.scss';
    import './styles/components/_swiper.scss';
    import './styles/components/_flex.scss';
    import './styles/components/_card.scss';
    import './styles/components/_calc.scss';
    import './styles/components/_epaas-embed.scss';

    //plugins
    import './styles/plugins/_localmedia-login.scss';



// Import JS
import './js/index.js';

// Import JS Components
import './js/components/_epaas-embed.js';
import './js/components/_swiper.js';
import './js/components/_glightbox.js';
import './js/components/_block-video-inline.js';
import './js/components/_navbar.js';
import './js/components/_accordion.js';
import './js/components/_member.js';

if(document.body.classList.contains('page-template-page-calculator')) {
    import('./js/components/_calc.js');
}